/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Příprava probíhá`
};

const da_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Forberedelse i gang`
};

const de_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Vorbereitung läuft`
};

const en_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Processing`
};

const es_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Preparación en curso`
};

const fr_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Prépration en cours`
};

const hu_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Felkészítés folyamatban`
};

const it_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Preparazione in corso`
};

const nl_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Voorbereiding bezig`
};

const pl_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Przygotowanie w toku`
};

const pt_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Preparação em andamento`
};

const sv_order_statuses_pending_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Förbereds`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_pending_processing = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_pending_processing(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_pending_processing", locale)
	if (locale === "cs") return cs_order_statuses_pending_processing(inputs)
	if (locale === "da") return da_order_statuses_pending_processing(inputs)
	if (locale === "de") return de_order_statuses_pending_processing(inputs)
	if (locale === "en") return en_order_statuses_pending_processing(inputs)
	if (locale === "es") return es_order_statuses_pending_processing(inputs)
	if (locale === "fr") return fr_order_statuses_pending_processing(inputs)
	if (locale === "hu") return hu_order_statuses_pending_processing(inputs)
	if (locale === "it") return it_order_statuses_pending_processing(inputs)
	if (locale === "nl") return nl_order_statuses_pending_processing(inputs)
	if (locale === "pl") return pl_order_statuses_pending_processing(inputs)
	if (locale === "pt") return pt_order_statuses_pending_processing(inputs)
	return sv_order_statuses_pending_processing(inputs)
};
export { order_statuses_pending_processing as "order_statuses.pending_processing" }